import React, { createContext, useContext } from "react";
export function createCtx() {
    var ctx = createContext(undefined);
    var useCtx = function() {
        var c = useContext(ctx);
        if (c === undefined) throw new Error('useCtx must be inside a Provider with a value');
        return c;
    };
    return [
        useCtx,
        ctx.Provider,
        ctx
    ];
}
export default createCtx;
